import { AssetActivityControlRequest, BULLJSJOBNAMES, BULLJSQUEUENAMES } from "@gtpl/shared-models/common-models";
import { InjectQueue } from "@nestjs/bull";
import { Injectable } from "@nestjs/common";
import { Queue } from "bull";
import { RedisConfigModel } from "../redis/models/redis-config.model";
import { RedisHelperService } from "../redis/redis-helper.service";
import { jobConfigs } from '../../../config';
import { DeviceRequest } from '@gtpl/shared-models/warehouse-management';
import { JobManagementApiService } from '@gtpl/shared-services/job-management-api';
const TPLinkSmartPlug = require('tplink-smartplug-node');
let tp = new TPLinkSmartPlug("192.168.0.46");

@Injectable()
export class AssentManagementJobService {
    private redisConfig;
    constructor(
        private redisHelper: RedisHelperService,
        private JobManagementApi: JobManagementApiService
    ) {
        this.redisConfig = new RedisConfigModel(jobConfigs.redis.port, jobConfigs.redis.host, jobConfigs.redis.password);
    }

    async  controlSmartPlug(): Promise<any> {
        tp.query().then(info => {
            console.log(info)
            console.log(info.system.get_sysinfo)
            if(info.system.get_sysinfo.relay_state == 0){
                tp.turnOn().then(onresp => {
                    console.log(onresp)
                    // resp should be { system: { set_relay_state: { err_code: 0 } } }
                });
            }else{
                tp.turnOff().then(offresp => {
                    console.log(offresp)
                    // resp should be { system: { set_relay_state: { err_code: 0 } } }
                });
            }
        })
        // tp.turnOn().then(resp => {
        //     tp.query().then(info => {
        //         console.log(info.relay_state)
        //     })
        //     console.log(resp)
        //     // resp should be { system: { set_relay_state: { err_code: 0 } } }
        // });
    }

    async triggerJobForAssetActivity(reqObj: AssetActivityControlRequest): Promise<boolean> {
        const jobConfigData = {
            repeat: { cron: reqObj.cronJobTime },
            jobId: reqObj.jobId,
        }
        const deviceRequest = new DeviceRequest(false,169,'192.168.0.166','FzHzpbLABOtcs2MBwlW6L7q30DDgqsT-O2uykUbS','lights',2,2,'state');
        await this.redisHelper.removeAllRepeatable(BULLJSQUEUENAMES.ASSET_ACTIVITY_CONTROLLER_JOB, this.redisConfig, jobConfigData);
        reqObj.assetControl ?
        await this.redisHelper.addJobToQueue(BULLJSQUEUENAMES.ASSET_ACTIVITY_CONTROLLER_JOB, reqObj, this.redisConfig, jobConfigData) : 
        // await this.JobManagementApi.triggerToControlTheBulb(deviceRequest);
        await this.JobManagementApi.controlSmartPlug();
        return true;
    }

    

    /**
       * Service to get cron pattern 
       * @param time Time 
    */
    getCronPatternFor24Format(date: string, hour: number, min: number):string{
        const splitDate = date.split('-');
        const year = splitDate[0];
        const month = splitDate[1];
        const day = splitDate[2];
        const dateFormate = new Date(date);
       return `${min} ${hour} ${day} ${month} ${dateFormate.getDay()}`;
    }
}